import { PayloadAction } from '@reduxjs/toolkit';
import { NotificationTypes } from '@dynamika-shared/types/subscription';

export enum NotificationDeliveryStatus {
  CREATED = 'CREATED',
  SENT = 'SENT',
  FAILED = 'FAILED',
}

export enum NotificationRecipientType {
  USER = 'USER',
  EMAIL = 'EMAIL',
}

export type NotificationHistoryItem = {
  id: string;
  messageId?: string;
  clinicalTrialId?: string;
  siteId?: string;
  siteCode?: string;
  patientCode?: string;
  notificationType: NotificationTypes;
  dispatchedAt?: string;
  recipientName?: string;
  recipientEmail?: string;
  recipientType?: NotificationRecipientType;
  deliveryStatus?: NotificationDeliveryStatus;
};

export type NotificationHistoryResponse = {
  content: NotificationHistoryItem[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  empty: boolean;
};

export type NotificationHistoryFilters = {
  notificationType?: NotificationTypes;
  status?: NotificationDeliveryStatus;
  recipientName?: string;
  recipientEmail?: string;
  dispatchedFrom?: string;
  dispatchedTo?: string;
};

export type ClinicalTrialNotificationHistoryState = {
  loading: boolean;
  error?: Error;
  data: NotificationHistoryResponse;
  filters: import('./notificationHistoryFilters.types').NotificationHistoryFiltersState;
};

export type FetchNotificationHistoryAction = PayloadAction<
  { clinicalTrialId: string; sort?: string } & NotificationHistoryFilters
>;

export type FetchNotificationHistorySuccessAction =
  PayloadAction<NotificationHistoryResponse>;
